module.exports = __webpack_public_path__ + "img/service1.f58a7a01.png";